import { getActivityIndex } from '../../utils/getActivityIndex';
import Definition from '@client/config/definition';
import unitHelper from '@client/helper/unit';
import { EMPTY_TEXT } from '../../../../../../config/other';
import { SportMode } from '@mytypes/activity-detail/ApiModel/SportMode';
import { i18n, i18nKeyValidateRegex } from '@client/helper/i18n';
import { h, Ref } from 'vue';
import { BottomTableColumnDefine } from '../types';
import { getIndexNew } from '../../utils/getIndexNew/getIndexNew';

type Inject = {
  listData: Ref<any>;
  isProgram: boolean;
  sportName: string;
  sportMode: SportMode;
  isAllDistanceRef: Ref<boolean>;
};

export function getStrengthActionName(inject: Inject): Record<string, BottomTableColumnDefine> {
  const { t } = i18n;
  const { isProgram, sportName, sportMode, listData, isAllDistanceRef } = inject;

  const columns: Record<string, BottomTableColumnDefine> = {
    // 动作名称（目前仅健身使用）
    Action_Name: {
      title: t('H6012'),
      // minWidth: 180,
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record, rowIndex }) {
        const activityIndex = getIndexNew({
          data: record,
          isProgram,
          sportMode,
          sportName
        });
        let name = '';
        if (record.exerciseNameKey && i18nKeyValidateRegex.test(record.exerciseNameKey)) {
          name = t(record.exerciseNameKey);
        } else {
          name = record.exerciseNameKey || EMPTY_TEXT;
        }
        return [
          h('span', { class: 'activity-index' }, activityIndex),
          h('span', { style: { opacity: activityIndex ? 1 : 0.5 }, class: 'activity-name' }, name)
        ];
      }
    }
  };

  return columns;
}
